import en from './translations/en';
import zh from './translations/zh';
import vi from './translations/vi';

export const supportedLocales = ['en', 'zh', 'vi'] as const; // WIP: full list ['en', 'zh', 'ja', 'vi', 'ko']
export type Locale = typeof supportedLocales[number];
export const resources = {
  en: {
    translation: en,
  },
  zh: {
    translation: zh,
  },
  vi: {
    translation: vi,
  },
} as const;
